import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Products from './components/Products';
import BecomeMerchant from './components/BecomeMerchant';
import AboutUs from './components/AboutUs';
import Tutorials from './components/Tutorials';
import './app.css';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar /> 
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/products" element={<Products />} />
            <Route path="/become-merchant" element={<BecomeMerchant />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/tutorials" element={<Tutorials />} />
          </Routes>
        </div>
        <Footer /> 
      </div>
    </Router>
  );
};

export default App;